import {
  Companion_getInstance13bmzv5tuee6 as Companion_getInstance,
  ReportedExceptionGroup2cus8du9ms53g as ReportedExceptionGroup,
} from './ReportedException.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareReportedExceptionGroupFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ReportedExceptionGroup__id_getInstance(), ReportedExceptionGroup_lastOccurredAt_getInstance(), ReportedExceptionGroup_count_getInstance(), ReportedExceptionGroup_context_getInstance(), ReportedExceptionGroup_server_getInstance(), ReportedExceptionGroup_message_getInstance(), ReportedExceptionGroup_trace_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ReportedExceptionGroup__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ReportedExceptionGroup__id$_get_name_$ref_552nuz() {
  return (p0) => p0.k20();
}
function ReportedExceptionGroup__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ReportedExceptionGroup__id$_get_serializer_$ref_58npyq() {
  return (p0) => p0.j2j();
}
function ReportedExceptionGroup__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ReportedExceptionGroup__id$_get_annotations_$ref_yj7qie() {
  return (p0) => p0.bz();
}
var ReportedExceptionGroup__idClass;
function ReportedExceptionGroup__id() {
  if (ReportedExceptionGroup__idClass === VOID) {
    class $ {
      constructor() {
        ReportedExceptionGroup__id_instance = this;
        var tmp = this;
        tmp.l32_1 = lazy(ReportedExceptionGroup__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m32_1 = lazy(ReportedExceptionGroup__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n32_1 = lazy(ReportedExceptionGroup__id$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.l32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ReportedExceptionGroup__id$_get_name_$ref_552nuz(), null);
        return tmp0.f2();
      }
      o32(receiver) {
        return receiver.p32_1;
      }
      m2j(receiver) {
        return this.o32(receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE());
      }
      w32(receiver, value) {
        return receiver.x32(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE();
        return this.w32(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ReportedExceptionGroup__id$_get_serializer_$ref_58npyq(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ReportedExceptionGroup__id$_get_annotations_$ref_yj7qie(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ReportedExceptionGroup__id', VOID, VOID, [SerializableProperty()]);
    ReportedExceptionGroup__idClass = $;
  }
  return ReportedExceptionGroup__idClass;
}
var ReportedExceptionGroup__id_instance;
function ReportedExceptionGroup__id_getInstance() {
  if (ReportedExceptionGroup__id_instance === VOID)
    new (ReportedExceptionGroup__id())();
  return ReportedExceptionGroup__id_instance;
}
function ReportedExceptionGroup_lastOccurredAt$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ReportedExceptionGroup_lastOccurredAt$_get_name_$ref_spi1h3() {
  return (p0) => p0.k20();
}
function ReportedExceptionGroup_lastOccurredAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ReportedExceptionGroup_lastOccurredAt$_get_serializer_$ref_alouua() {
  return (p0) => p0.j2j();
}
function ReportedExceptionGroup_lastOccurredAt$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ReportedExceptionGroup_lastOccurredAt$_get_annotations_$ref_sg99nm() {
  return (p0) => p0.bz();
}
var ReportedExceptionGroup_lastOccurredAtClass;
function ReportedExceptionGroup_lastOccurredAt() {
  if (ReportedExceptionGroup_lastOccurredAtClass === VOID) {
    class $ {
      constructor() {
        ReportedExceptionGroup_lastOccurredAt_instance = this;
        var tmp = this;
        tmp.y32_1 = lazy(ReportedExceptionGroup_lastOccurredAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z32_1 = lazy(ReportedExceptionGroup_lastOccurredAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a33_1 = lazy(ReportedExceptionGroup_lastOccurredAt$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.b33_1 = get_default(Companion_instance).d1m();
        this.c33_1 = 'now()';
      }
      k20() {
        var tmp0 = this.y32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ReportedExceptionGroup_lastOccurredAt$_get_name_$ref_spi1h3(), null);
        return tmp0.f2();
      }
      o32(receiver) {
        return receiver.q32_1;
      }
      m2j(receiver) {
        return this.o32(receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE());
      }
      d33(receiver, value) {
        return receiver.x32(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE();
        return this.d33(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ReportedExceptionGroup_lastOccurredAt$_get_serializer_$ref_alouua(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ReportedExceptionGroup_lastOccurredAt$_get_annotations_$ref_sg99nm(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ReportedExceptionGroup_lastOccurredAt', VOID, VOID, [SerializableProperty()]);
    ReportedExceptionGroup_lastOccurredAtClass = $;
  }
  return ReportedExceptionGroup_lastOccurredAtClass;
}
var ReportedExceptionGroup_lastOccurredAt_instance;
function ReportedExceptionGroup_lastOccurredAt_getInstance() {
  if (ReportedExceptionGroup_lastOccurredAt_instance === VOID)
    new (ReportedExceptionGroup_lastOccurredAt())();
  return ReportedExceptionGroup_lastOccurredAt_instance;
}
function ReportedExceptionGroup_count$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ReportedExceptionGroup_count$_get_name_$ref_v4ncg0() {
  return (p0) => p0.k20();
}
function ReportedExceptionGroup_count$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ReportedExceptionGroup_count$_get_serializer_$ref_ogkktj() {
  return (p0) => p0.j2j();
}
function ReportedExceptionGroup_count$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ReportedExceptionGroup_count$_get_annotations_$ref_6ytlsb() {
  return (p0) => p0.bz();
}
var ReportedExceptionGroup_countClass;
function ReportedExceptionGroup_count() {
  if (ReportedExceptionGroup_countClass === VOID) {
    class $ {
      constructor() {
        ReportedExceptionGroup_count_instance = this;
        var tmp = this;
        tmp.e33_1 = lazy(ReportedExceptionGroup_count$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f33_1 = lazy(ReportedExceptionGroup_count$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g33_1 = lazy(ReportedExceptionGroup_count$annotations$delegate$lambda);
        this.h33_1 = 1;
        this.i33_1 = '1';
      }
      k20() {
        var tmp0 = this.e33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ReportedExceptionGroup_count$_get_name_$ref_v4ncg0(), null);
        return tmp0.f2();
      }
      o32(receiver) {
        return receiver.r32_1;
      }
      m2j(receiver) {
        return this.o32(receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE());
      }
      w32(receiver, value) {
        return receiver.x32(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE();
        return this.w32(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ReportedExceptionGroup_count$_get_serializer_$ref_ogkktj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ReportedExceptionGroup_count$_get_annotations_$ref_6ytlsb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ReportedExceptionGroup_count', VOID, VOID, [SerializableProperty()]);
    ReportedExceptionGroup_countClass = $;
  }
  return ReportedExceptionGroup_countClass;
}
var ReportedExceptionGroup_count_instance;
function ReportedExceptionGroup_count_getInstance() {
  if (ReportedExceptionGroup_count_instance === VOID)
    new (ReportedExceptionGroup_count())();
  return ReportedExceptionGroup_count_instance;
}
function ReportedExceptionGroup_context$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ReportedExceptionGroup_context$_get_name_$ref_g0u2n4() {
  return (p0) => p0.k20();
}
function ReportedExceptionGroup_context$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ReportedExceptionGroup_context$_get_serializer_$ref_429eyv() {
  return (p0) => p0.j2j();
}
function ReportedExceptionGroup_context$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ReportedExceptionGroup_context$_get_annotations_$ref_f5ez() {
  return (p0) => p0.bz();
}
var ReportedExceptionGroup_contextClass;
function ReportedExceptionGroup_context() {
  if (ReportedExceptionGroup_contextClass === VOID) {
    class $ {
      constructor() {
        ReportedExceptionGroup_context_instance = this;
        var tmp = this;
        tmp.j33_1 = lazy(ReportedExceptionGroup_context$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k33_1 = lazy(ReportedExceptionGroup_context$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l33_1 = lazy(ReportedExceptionGroup_context$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.j33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ReportedExceptionGroup_context$_get_name_$ref_g0u2n4(), null);
        return tmp0.f2();
      }
      o32(receiver) {
        return receiver.s32_1;
      }
      m2j(receiver) {
        return this.o32(receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE());
      }
      m33(receiver, value) {
        return receiver.x32(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE();
        return this.m33(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ReportedExceptionGroup_context$_get_serializer_$ref_429eyv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ReportedExceptionGroup_context$_get_annotations_$ref_f5ez(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ReportedExceptionGroup_context', VOID, VOID, [SerializableProperty()]);
    ReportedExceptionGroup_contextClass = $;
  }
  return ReportedExceptionGroup_contextClass;
}
var ReportedExceptionGroup_context_instance;
function ReportedExceptionGroup_context_getInstance() {
  if (ReportedExceptionGroup_context_instance === VOID)
    new (ReportedExceptionGroup_context())();
  return ReportedExceptionGroup_context_instance;
}
function ReportedExceptionGroup_server$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function ReportedExceptionGroup_server$_get_name_$ref_34bpf0() {
  return (p0) => p0.k20();
}
function ReportedExceptionGroup_server$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ReportedExceptionGroup_server$_get_serializer_$ref_qa5n59() {
  return (p0) => p0.j2j();
}
function ReportedExceptionGroup_server$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function ReportedExceptionGroup_server$_get_annotations_$ref_hax99z() {
  return (p0) => p0.bz();
}
var ReportedExceptionGroup_serverClass;
function ReportedExceptionGroup_server() {
  if (ReportedExceptionGroup_serverClass === VOID) {
    class $ {
      constructor() {
        ReportedExceptionGroup_server_instance = this;
        var tmp = this;
        tmp.n33_1 = lazy(ReportedExceptionGroup_server$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o33_1 = lazy(ReportedExceptionGroup_server$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p33_1 = lazy(ReportedExceptionGroup_server$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.n33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ReportedExceptionGroup_server$_get_name_$ref_34bpf0(), null);
        return tmp0.f2();
      }
      o32(receiver) {
        return receiver.t32_1;
      }
      m2j(receiver) {
        return this.o32(receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE());
      }
      m33(receiver, value) {
        return receiver.x32(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE();
        return this.m33(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ReportedExceptionGroup_server$_get_serializer_$ref_qa5n59(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ReportedExceptionGroup_server$_get_annotations_$ref_hax99z(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ReportedExceptionGroup_server', VOID, VOID, [SerializableProperty()]);
    ReportedExceptionGroup_serverClass = $;
  }
  return ReportedExceptionGroup_serverClass;
}
var ReportedExceptionGroup_server_instance;
function ReportedExceptionGroup_server_getInstance() {
  if (ReportedExceptionGroup_server_instance === VOID)
    new (ReportedExceptionGroup_server())();
  return ReportedExceptionGroup_server_instance;
}
function ReportedExceptionGroup_message$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function ReportedExceptionGroup_message$_get_name_$ref_rhzqk8() {
  return (p0) => p0.k20();
}
function ReportedExceptionGroup_message$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ReportedExceptionGroup_message$_get_serializer_$ref_892zj3() {
  return (p0) => p0.j2j();
}
function ReportedExceptionGroup_message$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function ReportedExceptionGroup_message$_get_annotations_$ref_c76jyb() {
  return (p0) => p0.bz();
}
var ReportedExceptionGroup_messageClass;
function ReportedExceptionGroup_message() {
  if (ReportedExceptionGroup_messageClass === VOID) {
    class $ {
      constructor() {
        ReportedExceptionGroup_message_instance = this;
        var tmp = this;
        tmp.q33_1 = lazy(ReportedExceptionGroup_message$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r33_1 = lazy(ReportedExceptionGroup_message$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s33_1 = lazy(ReportedExceptionGroup_message$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.q33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ReportedExceptionGroup_message$_get_name_$ref_rhzqk8(), null);
        return tmp0.f2();
      }
      o32(receiver) {
        return receiver.u32_1;
      }
      m2j(receiver) {
        return this.o32(receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE());
      }
      m33(receiver, value) {
        return receiver.x32(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE();
        return this.m33(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ReportedExceptionGroup_message$_get_serializer_$ref_892zj3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ReportedExceptionGroup_message$_get_annotations_$ref_c76jyb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ReportedExceptionGroup_message', VOID, VOID, [SerializableProperty()]);
    ReportedExceptionGroup_messageClass = $;
  }
  return ReportedExceptionGroup_messageClass;
}
var ReportedExceptionGroup_message_instance;
function ReportedExceptionGroup_message_getInstance() {
  if (ReportedExceptionGroup_message_instance === VOID)
    new (ReportedExceptionGroup_message())();
  return ReportedExceptionGroup_message_instance;
}
function ReportedExceptionGroup_trace$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function ReportedExceptionGroup_trace$_get_name_$ref_diddje() {
  return (p0) => p0.k20();
}
function ReportedExceptionGroup_trace$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ReportedExceptionGroup_trace$_get_serializer_$ref_ul8bfh() {
  return (p0) => p0.j2j();
}
function ReportedExceptionGroup_trace$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function ReportedExceptionGroup_trace$_get_annotations_$ref_u1putd() {
  return (p0) => p0.bz();
}
var ReportedExceptionGroup_traceClass;
function ReportedExceptionGroup_trace() {
  if (ReportedExceptionGroup_traceClass === VOID) {
    class $ {
      constructor() {
        ReportedExceptionGroup_trace_instance = this;
        var tmp = this;
        tmp.t33_1 = lazy(ReportedExceptionGroup_trace$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u33_1 = lazy(ReportedExceptionGroup_trace$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v33_1 = lazy(ReportedExceptionGroup_trace$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.t33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ReportedExceptionGroup_trace$_get_name_$ref_diddje(), null);
        return tmp0.f2();
      }
      o32(receiver) {
        return receiver.v32_1;
      }
      m2j(receiver) {
        return this.o32(receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE());
      }
      m33(receiver, value) {
        return receiver.x32(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ReportedExceptionGroup() ? receiver : THROW_CCE();
        return this.m33(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ReportedExceptionGroup_trace$_get_serializer_$ref_ul8bfh(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ReportedExceptionGroup_trace$_get_annotations_$ref_u1putd(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ReportedExceptionGroup_trace', VOID, VOID, [SerializableProperty()]);
    ReportedExceptionGroup_traceClass = $;
  }
  return ReportedExceptionGroup_traceClass;
}
var ReportedExceptionGroup_trace_instance;
function ReportedExceptionGroup_trace_getInstance() {
  if (ReportedExceptionGroup_trace_instance === VOID)
    new (ReportedExceptionGroup_trace())();
  return ReportedExceptionGroup_trace_instance;
}
//region block: exports
export {
  prepareReportedExceptionGroupFields as prepareReportedExceptionGroupFields36kjijsp4e6fr,
};
//endregion

//# sourceMappingURL=ReportedExceptionGroupFields.mjs.map
